import React, { useState } from "react";
import axios from "axios";

import styles from "./EventsSearchPage.module.css";
import heroBg from "../assets/hero-crowd.jpg";

const EventsSearchPage = () => {
  const [results, setResults] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [keywordError, setKeywordError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchError, setSearchError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();

    const q = keyword.trim();
    if (!q) {
      setKeywordError("キーワードは必須です");
      setHasSearched(false);
      return;
    }

    setKeywordError("");
    setHasSearched(true);
    setSearchError("");
    setIsSearching(true);

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/events`, {
        params: {
          q,
          upcoming: true,
          limit: 20,
        },
      });
      setResults(res.data.events || []);
    } catch (err) {
      setResults([]);
      const status = err?.response?.status;
      if (status === 422) {
        setSearchError("キーワードは必須です");
      } else {
        setSearchError("検索に失敗しました。時間をおいて再度お試しください。");
      }
    } finally {
      setIsSearching(false);
    }
  };

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div
          className={styles.heroBg}
          style={{ backgroundImage: `url(${heroBg})` }}
          aria-hidden="true"
        />
        <div className={styles.heroOverlay} />

        <div className={styles.heroInner}>
          <h1 className={styles.heroTitle}>イベント検索</h1>

          <form className={styles.searchShell} onSubmit={onSubmit}>
            <div className={styles.searchRow}>
              <div className={styles.field}>
                <input
                  className={styles.input}
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    if (keywordError) setKeywordError("");
                    if (searchError) setSearchError("");
                  }}
                  placeholder="キーワードを入力"
                  aria-label="キーワード"
                />
              </div>

              <button type="submit" className={styles.searchButton} disabled={isSearching}>
                {isSearching ? "検索中..." : "検索"}
              </button>
            </div>

            {keywordError && <div className={styles.searchError}>{keywordError}</div>}
            {searchError && <div className={styles.searchError}>{searchError}</div>}
          </form>
        </div>
      </section>

      <section className={styles.listSection}>
        <div className={styles.listHeader}>
          <h2 className={styles.listTitle}>イベント一覧</h2>
          {hasSearched && <div className={styles.count}>{results.length}件のイベント</div>}
        </div>

        {!hasSearched ? (
          <div className={styles.empty}>キーワードを入力して検索してください</div>
        ) : isSearching ? (
          <div className={styles.empty}>検索中...</div>
        ) : results.length === 0 ? (
          <div className={styles.empty}>該当するイベントがありません</div>
        ) : (
          <div className={styles.list}>
            {results.map((event) => {
              const eventPathId = event?.slug || event?.id;
              const imgSrc = event?.flyers?.[0]?.url || null;
              const dateText = event?.date ? String(event.date).slice(0, 10) : "";
              const venueText = event?.venue ? `@ ${event.venue}` : "";

              return (
                <div key={event.id} className={styles.item}>
                  <div className={styles.thumbWrap}>
                    {imgSrc ? (
                      <img
                        src={imgSrc}
                        alt={`${event.name} flyer`}
                        className={styles.thumb}
                        loading="lazy"
                      />
                    ) : (
                      <div className={styles.noThumb}>No Image</div>
                    )}
                  </div>

                  <div className={styles.itemBody}>
                    <div className={styles.itemName}>{event.name}</div>
                    <div className={styles.itemMeta}>{dateText}</div>
                    <div className={styles.itemMeta}>{venueText}</div>
                  </div>

                  <div className={styles.itemAction}>
                    <a href={`/events/${eventPathId}`} className={styles.detailLink}>
                      <button className={styles.detailButton}>詳細を見る</button>
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default EventsSearchPage;
